var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1992 3.7002H4.79922C3.91522 3.7002 3.19922 4.4162 3.19922 5.3002V19.7002C3.19922 20.5842 3.91522 21.3002 4.79922 21.3002H19.1992C20.0832 21.3002 20.7992 20.5842 20.7992 19.7002V5.3002C20.7992 4.4162 20.0824 3.7002 19.1992 3.7002ZM18.1504 11.2794C18.0464 11.289 17.9416 11.2954 17.836 11.2954C16.64 11.2954 15.5888 10.681 14.9768 9.7506C14.9768 12.1898 14.9768 14.9658 14.9768 15.0122C14.9768 17.1602 13.2352 18.901 11.088 18.901C8.94082 18.9002 7.19922 17.1586 7.19922 15.0114C7.19922 12.8634 8.94082 11.1226 11.088 11.1226C11.1696 11.1226 11.2488 11.1298 11.328 11.1346V13.0514C11.248 13.0418 11.1704 13.0274 11.088 13.0274C9.99202 13.0274 9.10322 13.9162 9.10322 15.0122C9.10322 16.1082 9.99122 16.997 11.088 16.997C12.1848 16.997 13.1528 16.133 13.1528 15.037C13.1528 14.993 13.172 6.101 13.172 6.101H15.0032C15.1752 7.7386 16.4976 9.0314 18.1504 9.1498V11.2794Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.f9b2fa4e08c91da65eb30545ec9aff4f.svg";
export { ForwardRef as ReactComponent };